// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"cbdced56","737":"e105a2d6","887":"7e87ec43"}[chunkId] + ".chunk.css";
};